import React from "react";
import LoadingIndicator from "../../../meta/LoadingIndicator";


function NonActiveSurveyShare(props){
    const surveyName = props.surveyName

    function activateSurvey(){
        props.handlerActivateSurvey();
    }


    return <React.Fragment>
        <div className="questionaire__share">
            <div className="questionaire__share__title questionaire__share__title--mobile">
                Share
                <span className="questionaire__share__title__buble"></span>
            </div>
            <h1 className="questionaire__share__title">
                Congrats! You’ve finished creating<br/>
                {surveyName}
            </h1>
            <h2 className="questionaire__share__subTitle">
                Your survey status is currently set to DRAFT.<br/>
                In order to share this survey with your audience, you need to make your survey ACTIVE.<br/>
                After activating your survey, you won't be able to delete or reorder questions or choices.<br/>
            </h2>
            <br/>
            <div className="questionaire__share__actions">
                <div className="questionaire__share__actions__link">
                    {props.isProcessingActive ? <LoadingIndicator/> :
                        <button className="questionaire__share__actions__link__copy" onClick={activateSurvey}>
                            <span className="questionaire__share__actions__link__copy__tooltip">Activate Survey</span>
                            Activate Survey
                        </button>}

                </div>
            </div>
        </div>
    </React.Fragment>
}

export default NonActiveSurveyShare;